module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/birthdays/edit-birthday/edit-birthday.component.css
// module id = ./src/app/birthdays/edit-birthday/edit-birthday.component.css
// module chunks = main